import { fromBasket } from '@agent/core/basket';
import { BasketLabelModel, BasketStoreModel } from '@agent/core/basket/basket.model';
import { select, selectAll } from '@commons/util/utilities/store/entity.select';
import { map, OperatorFunction, pipe } from 'rxjs';

import { ChannelType } from '@contact/upgrade';

import { QueryFilterModel, VisioChannelModel } from './visio-basket.model';

export function selectVisioBasket(): OperatorFunction<BasketStoreModel, VisioChannelModel> {
  return fromBasket.selectChannelByType(ChannelType.VISIO);
}

export function selectQueryFilters(): OperatorFunction<BasketStoreModel, QueryFilterModel> {
  return pipe(
    selectVisioBasket(),
    select(s => s.queryFilters)
  );
}

export function selectLabelTotalCountByType(...type: string[]): OperatorFunction<BasketStoreModel, number> {
  return pipe(
    selectLabels(),
    map(labels => labels.filter(l => type.some(t => t === l.label))),
    map(filters => filters.reduce((acc, v) => acc + v.nbTotalRequests, 0))
  );
}

export function selectLabels<T extends BasketLabelModel>(): OperatorFunction<BasketStoreModel, T[]> {
  return pipe(
    fromBasket.selectChannelByType(ChannelType.VISIO),
    map(s => s.labels),
    selectAll<T>()
  );
}
